module.exports = __webpack_public_path__ + "static/media/3.7bb3c840.jpg";